export default "__VITE_ASSET__DLnrtefq__"